module.exports = import("https://esm.sh/remark-gfm@4");;